import apiClient from './client';

export interface AdNote {
  _id: string;
  text: string;
  createdAt: string;
}

export interface AdAnnotation {
  _id: string;
  accountId: string;
  adId: string;
  tags: string[];
  notes: AdNote[];
  createdAt: string;
  updatedAt: string;
}

export async function listAnnotations(accountId?: string): Promise<AdAnnotation[]> {
  const params = new URLSearchParams();
  if (accountId) params.append('accountId', accountId);
  const res = await apiClient.get(`/ad-annotations?${params.toString()}`);
  return res.data.annotations;
}

export async function listTags(accountId?: string): Promise<string[]> {
  const params = new URLSearchParams();
  if (accountId) params.append('accountId', accountId);
  const res = await apiClient.get(`/ad-annotations/tags?${params.toString()}`);
  return res.data.tags;
}

export async function setTags(
  accountId: string,
  adId: string,
  tags: string[]
): Promise<AdAnnotation> {
  const res = await apiClient.put('/ad-annotations/tags', { accountId, adId, tags });
  return res.data.annotation;
}

export async function addNote(
  accountId: string,
  adId: string,
  text: string
): Promise<AdAnnotation> {
  const res = await apiClient.post('/ad-annotations/notes', { accountId, adId, text });
  return res.data.annotation;
}

export async function deleteNote(
  annotationId: string,
  noteId: string
): Promise<AdAnnotation> {
  const res = await apiClient.delete(`/ad-annotations/${annotationId}/notes/${noteId}`);
  return res.data.annotation;
}
